import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import { selectNotificationsByScope } from 'features/notifications/notificationsSlice';
import { NotificationId } from 'features/notifications/types';
import { closeActionNotifications } from 'features/notifications/thunks/closeActionNotifications';
import { FeatureFlag } from 'features/feature-set/types';

export function* cleanupQANotificationsSaga(id: string) {
  const notificationIds: NotificationId[] = yield select(
    selectNotificationsByScope,
    FeatureFlag.qa
  );

  const filteredNotificationIds: NotificationId[] = notificationIds.filter((notificationId) => {
    if (typeof notificationId !== 'string') {
      return false;
    }

    return notificationId.includes(id);
  });

  if (filteredNotificationIds.length) {
    const cleanupNotificationsThunk: Action = yield call(
      closeActionNotifications,
      filteredNotificationIds
    );
    yield put(cleanupNotificationsThunk);
  }
}
